import React, { useContext } from "react";
import { isEmpty, get, parseInt } from "lodash";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { Form, Row, Col } from "react-bootstrap";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { faTimes, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {
  ManageCompanyLayout,
  FormControl,
  DatePicker,
  FieldDropSide,
  FieldTextarea,
  SliderPanel,
  CsplTable as Table,
  AddToolTip,
  DeleteWarning,
} from "../../components";
import {
  manageCompanyStore,
  setManageCompanyLocalCache,
  setManageCompanyToastInfo,
} from "../../contexts";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  ROUTES,
  MANAGE_COMPANY_ROUTES,
  manageCompanyFormNames,
  formFields,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  usDateFormat,
  required,
} from "../../utils";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getNotificationSwitchHistoryForPayDate } from "../../services";

const columns = [
  // {
  //   label: " ",
  //   className: "column-sno",
  //   columnName: "sno",
  // },
  {
    label: "Suppress late payroll notifications?",
    className: "column-pay-date",
    columnName: "suppressLatePayrollNotifications",
    //link: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
  },
  {
    label: "Notes",
    className: "column-pay-period-begin-date",
    columnName: "notes",
  },
  {
    label: "Date",
    className: "column-pay-period-end-date",
    columnName: "Date",
  },
  // {
  //   label: "Pay period status",
  //   className: "column-pay-period-status",
  //   columnName: "payPeriodStatus",
  // },
  // {
  //   label: "Suppress late payroll notifications?",
  //   className: "column-notification-switch",
  //   columnName: "notificationSwitch",
  // },
];

const PayrollCalendarManagePayDatesContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageCompanyStore);
  const {
    companyId,
    flow,
    frequencyId,
    payDateId,
    offset,
    checked,
  } = useRouterParams();
  const intFrequencyId = parseInt(frequencyId, 10);

  const [notificationHistory, setNotificationHistory] = useState([]);
  const DeleteToastMessage = "You are attempting to delete pay date.";
  const DeleteToastMessageHead = "Delete Pay date?";
  const [showWarning, setShowWarning] = useState(false);
  const [tempNote, setTempNote] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);

  useDeepEffect(() => {
    setIsApiLoading(true);
    getNotificationSwitchHistoryForPayDate(payDateId).then((response) => {
      setNotificationHistory(response.notificationHistory);
      setIsApiLoading(false);
    });
  }, [payDateId]);
  useDeepEffect(() => {
    let noteState = patPeriodsForPayDateId?.notificationSwitch;
    let tempArray = [...notificationHistory].reverse();
    setTempNote(
      tempArray?.filter((item, index) => {
        if (item.notificationSwitch != noteState) {
          noteState = item.notificationSwitch;
          return true;
        } else return false;
      })
    );
  }, [notificationHistory]);

  const intPayDateId =
    parseInt(checked, 10) === 1
      ? parseInt(offset, 10) + parseInt(payDateId, 10)
      : parseInt(payDateId, 10);

  const formName =
    manageCompanyFormNames.PAYROLL_CALENDAR_ADDPAYDATES_MANAGE_COMPANY;
  const fields = formFields[formName];
  const payrollCalendarListData = get(state, "payrollCalendar", []);
  const payrollCalendarForFrquencyId = get(
    payrollCalendarListData,
    intFrequencyId,
    {}
  );
  const prevFlow = get(state, "prevFlow", []);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const payPeriodsListData = get(state, "payrollCalendarPayPeriods", []);
  const patPeriodsForPayDateId = payPeriodsListData.filter(
    (x) => x.id == intPayDateId
  )[0];
  let status = payPeriodsListData
    .filter((item) => item?.id == patPeriodsForPayDateId?.id)
    .map(({ id, payPeriodStatus }) => [{ id, payPeriodStatus }]);
  const schema = Yup.object().shape({
    beginDate: Yup.date().nullable().required("CM061 : Required"),
    endDate: Yup.date()
      .nullable()
      .required("CM062 : Required")
      .when("beginDate", {
        is: null,
        otherwise: Yup.date().when("endDate", {
          is: null,
          otherwise: Yup.date().min(
            Yup.ref("beginDate"),
            "CM063 : Period Begin Date should be prior or equal to the Period End Date."
          ),
        }),
      }),
    payDate: Yup.date()
      .nullable()
      .required("CM064 : Required")
      .when("endDate", {
        is: null,
        otherwise: Yup.date().when("payDate", {
          is: null,
          otherwise: Yup.date().min(
            Yup.ref("endDate"),
            "CM065 : Pay Date should be equal or later than Period End Date"
          ),
        }),
      }),
  });

  const checkOverlapPayPeriodForBeginDate = (beginDate) => {
    var overlap = false;
    payPeriodsListData.map((item, index) => {
      if (
        item.id != intPayDateId &&
        new Date(usDateFormat(beginDate)) >=
          new Date(usDateFormat(item.beginDate)) &&
        new Date(usDateFormat(beginDate)) <=
          new Date(usDateFormat(item.endDate))
      ) {
        overlap = true;
        return true;
      }
    });
    return overlap;
  };
  const checkOverlapPayPeriodForEndDate = (endDate) => {
    var overlap = false;
    payPeriodsListData.map((item, index) => {
      if (
        item.id != intPayDateId &&
        new Date(usDateFormat(endDate)) >=
          new Date(usDateFormat(item.beginDate)) &&
        new Date(usDateFormat(endDate)) <= new Date(usDateFormat(item.endDate))
      ) {
        overlap = true;
        return true;
      }
    });
    return overlap;
  };
  const checkPayDate = (payDate) => {
    const d1 = new Date(usDateFormat(payDate));
    var exists = false;
    payPeriodsListData.map((item, index) => {
      const d2 = new Date(usDateFormat(item.payDate));
      if (item.id != intPayDateId && d1.getTime() === d2.getTime()) {
        exists = true;
        return true;
      }
    });
    return exists;
  };
  const getDataForSave = (values) => {
    let payPeriods = [];
    if (isEmpty(patPeriodsForPayDateId) && !isEmpty(values)) {
      payPeriods = [
        ...payPeriodsListData,
        {
          ...values,
        },
      ];
    } else {
      payPeriods = payPeriodsListData.map((item, index) => {
        if (item.id === intPayDateId) {
          return { ...item, ...values };
        }
        return item;
      });
    }

    return payPeriods;
  };

  const onDeleteClick = () => {
    setShowWarning(false);
    const payrollCalendarFormValues = get(state, formName, {});
    const payPeriods = payPeriodsListData.filter(
      (_, index) => _.id !== parseInt(payDateId)
    );
    dispatch(
      setManageCompanyLocalCache({
        model: "payrollCalendarPayPeriods",
        data: payPeriods,
      })
    );
    dispatch(
      setManageCompanyToastInfo({
        showToast: true,
        toastMessage: "Data deleted successfully",
      })
    );
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
        pathParam: [prevFlow, companyId, frequencyId],
      })
    );
  };

  const handleConfirmClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const onFormSubmit = (values, { setFieldError }) => {
    if (
      checkOverlapPayPeriodForEndDate(values[fields.endDate]) ||
      checkOverlapPayPeriodForBeginDate(values[fields.beginDate])
    ) {
      setFieldError(
        "endDate",
        "CM072 : Pay Period overlaps with existing Pay Period"
      );
    } else if (checkPayDate(values[fields.payDate])) {
      setFieldError("payDate", "CM076 : Paydate already exists");
    } else if (
      values["notificationNotes"] &&
      values["notificationNotes"].length > 51
    ) {
      setFieldError(
        "notificationNotes",
        "CM076 : Note cannot exceed 50 characters"
      );
    } else {
      dispatch(
        setManageCompanyLocalCache({
          model: "payrollCalendarPayPeriods",
          data: getDataForSave(values),
        })
      );

      dispatch(
        setManageCompanyToastInfo({
          showToast: true,
          toastMessage:
            flow === FLOW_TYPES.ADD
              ? `Pay Date for ${frequencyName} created successfully`
              : "Data saved successfully",
        })
      );
      history.push(
        getAdvancedPathWithParam({
          path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
          pathParam: [flow, companyId, frequencyId],
        })
      );
    }
  };

  const buttons = [
    {
      link: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
        pathParam: [flow, companyId, frequencyId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
        pathParam: [prevFlow, companyId, frequencyId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      disabled: patPeriodsForPayDateId?.payPeriodStatus == 2 ? true : false,
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
            pathParam: [
              FLOW_TYPES.SAVE,
              companyId,
              frequencyId,
              payDateId,
              offset,
              checked,
            ],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      disabled: patPeriodsForPayDateId?.payPeriodStatus == 2 ? true : false,
      onClick: handleConfirmClick,
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTimes,
    //   link: getAdvancedPathWithParam({
    //     path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
    //     pathParam: [flow, companyId, frequencyId],
    //   }),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faPencilAlt,
    //   disabled: patPeriodsForPayDateId?.payPeriodStatus == 2 ? true : false,
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
    //         pathParam: [
    //           FLOW_TYPES.SAVE,
    //           companyId,
    //           frequencyId,
    //           payDateId,
    //           offset,
    //           checked,
    //         ],
    //       })
    //     ),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   disabled: patPeriodsForPayDateId?.payPeriodStatus == 2 ? true : false,
    //   onClick: onDeleteClick,
    // },
  ];

  const {
    frequencyName,
    scheduleBeginDate,
    scheduleEndDate,
  } = payrollCalendarForFrquencyId;

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const initialValues = {};
  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          ...patPeriodsForPayDateId,
        }}
        validationSchema={schema}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          errors,
          values,
          ...rest
        }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <ManageCompanyLayout buttons={buttons} pageFlow={flow}>
                <Row>
                  <Col>
                    <div className="d-flex">
                      <FormControl isRequired label="Frequency name" {...rest}>
                        <Form.Control
                          type="text"
                          value={frequencyName}
                          disabled
                        />
                      </FormControl>
                      &nbsp;&nbsp;&nbsp;
                      <FormControl
                        isRequired
                        label="Schedule begin date"
                        size="sm"
                        {...rest}
                      >
                        <Form.Control
                          type="text"
                          value={usDateFormat(scheduleBeginDate)}
                          disabled
                        />
                      </FormControl>
                      &nbsp;&nbsp;&nbsp;
                      <FormControl
                        isRequired
                        label="Schedule end date"
                        size="sm"
                        {...rest}
                      >
                        <Form.Control
                          type="text"
                          value={usDateFormat(scheduleEndDate)}
                          disabled
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      label="Period begin date"
                      name={fields.beginDate}
                      isRequired
                      size="md"
                      value={usDateFormat(values[fields.beginDate])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.beginDate, null)}
                      popupContent={
                        <DatePicker
                          minDate={new Date(scheduleBeginDate)}
                          onDayClick={(value) =>
                            onDaySelected(fields.beginDate, value)
                          }
                          value={usDateFormat(values[fields.beginDate])}
                        />
                      }
                      disabled={isEdit && !isSave}
                      validate={required}
                      component={FieldDropSide}
                    />
                    <Field
                      label="Period end date"
                      name={fields.endDate}
                      isRequired
                      size="md"
                      value={usDateFormat(values[fields.endDate])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.endDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.endDate, value)
                          }
                          value={usDateFormat(values[fields.endDate])}
                        />
                      }
                      disabled={isEdit && !isSave}
                      validate={required}
                      component={FieldDropSide}
                    />
                    <Field
                      label="Pay date"
                      name={fields.payDate}
                      isRequired
                      size="md"
                      value={usDateFormat(values[fields.payDate])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.payDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.payDate, value)
                          }
                          value={usDateFormat(values[fields.payDate])}
                        />
                      }
                      disabled={isEdit && !isSave}
                      validate={required}
                      component={FieldDropSide}
                    />
                    <DeleteWarning
                      DeleteToastMessageHead={DeleteToastMessageHead}
                      DeleteToastMessage={DeleteToastMessage}
                      showModal={showWarning}
                      handleConfirmClick={onDeleteClick}
                      handleCancelClick={handleCancelClick}
                    />
                    {state?.settings_managecompany?.isLatePayrollApplicable && (
                      <>
                        <Field
                          size="smd"
                          // isRequired
                          placeholder=""
                          label={"Notes"}
                          name={"notificationNotes"}
                          type="text"
                          value={values["notificationNotes"]}
                          disabled={isEdit && !isSave}
                          onChange={handleChange}
                          component={FieldTextarea}
                        />
                        <Link onClick={() => setIsSliderOpen(true)}>
                          View History
                        </Link>
                      </>
                    )}
                  </Col>
                </Row>
              </ManageCompanyLayout>
            </Form>
          );
        }}
      </Formik>
      <SliderPanel
        isOpen={isSliderOpen}
        size="70"
        showCancel={true}
        onClose={() => setIsSliderOpen(!isSliderOpen)}
      >
        <p className="fw-500 ft-16">
          Late Payroll Notification Suppression History
        </p>
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody isLoading={isApiLoading} totalRecords={tempNote?.length}>
            {tempNote?.map((payrollFrequency, index) => {
              return (
                <Table.Tr key={index}>
                  {columns.map((item, cellIndex) => {
                    return (
                      <Table.Td key={cellIndex} className={item.className}>
                        {item.columnName ==
                          "suppressLatePayrollNotifications" && (
                          <div>
                            {payrollFrequency.notificationSwitch == true
                              ? "Yes"
                              : "No"}
                          </div>
                        )}
                        {
                          item.columnName == "notes" &&
                            (payrollFrequency?.notificationNotes?.length >
                            25 ? (
                              <AddToolTip
                                className="link-text"
                                name={payrollFrequency.notificationNotes}
                                //placement="bottom"
                              >
                                {(
                                  payrollFrequency.notificationNotes || ""
                                ).slice(0, 25)}
                                ...
                              </AddToolTip>
                            ) : (
                              <div className="content-item">
                                {payrollFrequency.notificationNotes}
                              </div>
                            ))
                          //<div>{payrollFrequency.notificationNotes}</div>
                        }
                        {item.columnName == "Date" && (
                          <div>{usDateFormat(payrollFrequency.createdOn)}</div>
                        )}
                      </Table.Td>
                    );
                  })}
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </SliderPanel>
    </>
  );
};

export default PayrollCalendarManagePayDatesContainer;
